module.exports = __webpack_public_path__ + "img/2Q.0bcb7609.png";